import type { R } from "../types";
import { axiosInstance } from "../../axios-instance";
import qs from "qs";
import { qsOptions } from "../qsOptions";
import type { AxiosRequestConfig } from "axios";
import type {
  IDeleteLoanProcessorRequest,
  IDeleteLoanProcessorResponse,
  IGetLoanProcessorProfileByUserIdRequest,
  IGetLoanProcessorProfileByUserIdResponse,
  IGetLoanProcessorsRequest,
  IGetLoanProcessorsResponse,
  IUpdateLoanProcessorRequest,
  IUpdateLoanProcessorResponse,
} from "./types";

export class LoanProcessorsService {
  async listLoanProcessors(
    p: IGetLoanProcessorsRequest,
    c?: AxiosRequestConfig,
  ): R<IGetLoanProcessorsResponse> {
    try {
      const params = qs.stringify(p, qsOptions);
      return axiosInstance.get(`/api/loanProcessor/all?${params}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async deleteLoanProcessor(
    p: IDeleteLoanProcessorRequest,
    c?: AxiosRequestConfig,
  ): R<IDeleteLoanProcessorResponse> {
    try {
      return axiosInstance.delete(`/api/loanProcessor/${p.userId}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getProfileByUserId(
    p: IGetLoanProcessorProfileByUserIdRequest,
    c?: AxiosRequestConfig,
  ): R<IGetLoanProcessorProfileByUserIdResponse> {
    try {
      return axiosInstance.get(`/api/loanProcessor/user/${p.userId}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async updateProfile(
    p: IUpdateLoanProcessorRequest,
    c?: AxiosRequestConfig,
  ): R<IUpdateLoanProcessorResponse> {
    try {
      return axiosInstance.put(`/api/loanProcessor/updateLoanProcessor`, p, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
